export enum PageReportTemplate {
  DEFAULT = 'Showing {first}-{last} of {totalRecords}',
  ACCOUNTS_PAGE = 'Showing {first}-{last} of {totalRecords}',
  ORGANIZATION_PAGE = 'Showing {first}-{last} of {totalRecords}',
  LOQ_ANNOUNCEMENT_PAGE = 'Showing {first}-{last} of {totalRecords}',
}
